import { PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { consentService } from "../api/consentService";

interface Props {
	name: string;
	label: string;
	disabled?: boolean;
	required?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(consentService);
export const ConsentMultiSelect: FC<Props> = ({ name, label, disabled, required = false }) => {
	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			disabled={disabled}
			fetchConfig={fetchConfig}
			getLabel={(option) => option.name}
			clearable={true}
			required={required}
		/>
	);
};
